import Vue from 'vue';
import InputText from 'primevue/inputtext';

Vue.component('InputText', InputText);
